import "./navigationBar.css"

import clickHere from "../../images/click_here.svg"
import avatar from "../../images/avatar.svg"
import githubIcon from "../../images/nav-icons/github_icon.svg"
import linkedinIcon from "../../images/nav-icons/linkedin_icon.svg"
import leetcodeIcon from "../../images/nav-icons/leetcode_icon.svg"
import resumeIcon from "../../images/nav-icons/resume_icon.svg"

import { useState, useEffect } from 'react'

const NavButton = ({ icon, url }) => (
    <a className="nav-btn" href={url} target="_blank" rel="noreferrer">
        <img className="nav-btn-icon" src={icon} alt="navigation button" />
    </a>
)

const FloatingActionButton = ({ icon, toggleMenu, removeClickMe }) => (
    <div
        className={"fab-btn"}
        onClick={() => {
            if (removeClickMe != null) removeClickMe()
            toggleMenu()
        }}
    >
        <img className="fab-icon" src={icon} alt="floating action button" />
    </div>
)

export default function NavigationBar() {
    const [isOpen, setIsOpen] = useState(false)
    const [isTopVisible, setIsTopVisible] = useState(true)
    const [disableClickMe, setDisableClickMe] = useState(false)

    const changeNavBar = () => {
        if (window.scrollY >= 150) {
            setIsTopVisible(false)
            setIsOpen(false)
        } else {
            setIsTopVisible(true)
        }
    }

    useEffect(() => {
        console.log('Scrolling...')
        window.addEventListener('scroll', changeNavBar)
        return () => {
            window.removeEventListener('scroll', changeNavBar)
        }
    }, [])

    const toggleMenu = () => {
        setIsOpen(!isOpen)
    }

    const removeClickMe = () => {
        setDisableClickMe(true)
    }

    return (
        <div id="nav-container">
            <img
                style={{
                    opacity: disableClickMe ? 0 : 100
                }}
                id="click-here"
                src={clickHere}
                alt="Click Here!"
            />
            <nav className={`navbar ${isOpen ? 'open' : ''} ${isTopVisible ? '' : 'float'}`}>
                <NavButton
                    icon={leetcodeIcon}
                    url={'https://leetcode.com/smitrajrana57/'}
                />
                <NavButton icon={githubIcon}
                    url={'https://github.com/Smit56R'}
                />
                {
                    isTopVisible &&
                    <FloatingActionButton
                        icon={avatar}
                        toggleMenu={toggleMenu}
                        removeClickMe={removeClickMe}
                    />
                }
                <NavButton icon={linkedinIcon}
                    url={'https://www.linkedin.com/in/smitraj-rana-41072220a/'}
                />
                <NavButton icon={resumeIcon}
                    url={"https://drive.google.com/file/d/1dcMjpZxwXtRTLSHEeq82161BeH8zdyso/view?usp=sharing"}
                />
                {
                    !isTopVisible &&
                    <FloatingActionButton
                        icon={avatar}
                        toggleMenu={toggleMenu}
                    />
                }
            </nav>
        </div>
    )
}